// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3HwJJ","options":"AnswerScale_options__2VIdV","selected":"AnswerScale_selected__3xIIk"};